import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ImageFetch from "./ImageFetch";
import { useEffect, useState,memo } from "react";

// owl carousel settings
const backgroundSettings = {
    center: false,
    items: 1,
    loop: false,
    margin: 14,
    nav: true,
    autoplay: false,
    autoWidth: true,
    dots: false,
  };
const BASE_URL = "https://hh-devserver-bucket.s3.us-east-2.amazonaws.com/Assets/Images/Meme-Generator-Assets/Backgrounds/"
export default memo(({bannerBackgrounds,selectBanner})=>{
  const [loader,setLoader] = useState(true)
  const [reRender,setRerender] = useState(false)
  const incrementLoader = () => {
      setLoader(false)
  }
  useEffect(()=>{
      setLoader(true)
      setRerender(!reRender)
  },[])  
    return(
        <div id="slider-block">
              <h3 className="slider-title">Select Backgrounds:</h3>
              {loader ? <div className="loader"></div> :<></>}
              <OwlCarousel
                className="artis-slider  owl-theme" 
                {...backgroundSettings}
              >
                {bannerBackgrounds.map((bg,index) => {
                  return (
                    <ImageFetch 
                    addAssets={(img)=>{console.log(img) 
                      selectBanner(img.image)}} 
                    link={BASE_URL+ bg} 
                    incrementLoader = {incrementLoader} 
                    imagesLoaded={true} 
                    reRender={reRender} 
                    selectedCategory={""}
                    key={index}
                    />
                  );
                })}
              </OwlCarousel>
            </div>
    )
})